import { createRouter, createWebHistory } from "vue-router";
import IndexLandingPage from "@/pages/IndexLandingPage.vue";
import IndexHomePage from "@/pages/IndexHomePage.vue";
import IndexLOARequestPage from "@/pages/IndexLOARequestPage.vue";
import IndexOnboardPage from "@/pages/IndexOnboardPage.vue";
import IndexOnboardIMSPage from "@/pages/IndexOnboardingIMSPage.vue";
import IndexTransactionHistoryPage from "@/pages/IndexTransactionPage.vue";
import IndexTransactionHistoryDetailPage from "@/pages/IndexTransactionDetailPage.vue";
import IndexPolicyDetailPage from "@/pages/IndexPolicyDetailPage.vue";
import IndexBirthdateForm from "@/pages/IndexBirthdateUpdate.vue";
import IndexLearnMorePage from "@/pages/IndexLearnMore.vue";
import IndexInformationCenter from "@/pages/support-center/IndexInformationCenter.vue";
import IndexInformationCenterAvailment from "@/pages/support-center/IndexInformationAvailmentProcess.vue";
import IndexInformationCenterFAQ from "@/pages/support-center/IndexInformationFAQ.vue";
import IndexInformationCenterVideos from "@/pages/support-center/IndexInformationVideoGuide.vue";

import IndexContactUsPage from "@/pages/IndexContactPage.vue";

const routes = [
  {
    path: "/",
    name: "onboard",
    component: IndexOnboardPage,
    meta: {
      title: "Welcome to AMAP",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/ims",
    name: "onboardIMS",
    component: IndexOnboardIMSPage,
    meta: {
      title: "Welcome to AMAP",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/auth",
    name: "auth",
    component: IndexLandingPage,
    meta: {
      title: "Login",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/auth/home",
    name: "home",
    component: IndexHomePage,
    meta: {
      title: "Home",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/request/loa",
    name: "RequestLOA",
    component: IndexLOARequestPage,
    meta: {
      title: "Request LOA",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/request/loa/transaction",
    name: "Transaction",
    component: IndexTransactionHistoryPage,
    meta: {
      title: "Transaction History",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/request/loa/transaction/detail/:id",
    name: "TransactionPerApproval",
    component: IndexTransactionHistoryDetailPage,
    meta: {
      title: "Transaction Details",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/policy/detail",
    name: "PolicyDetails",
    component: IndexPolicyDetailPage,
    meta: {
      title: "Policy Details",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/amap/birthdate/form/:id",
    name: "BirthdateForm",
    component: IndexBirthdateForm,
    meta: {
      title: "Birthdate Form",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/amap/learnmore",
    name: "learnmore",
    component: IndexLearnMorePage,
    meta: {
      title: "Learn More",
      layout: "General",
      requiresAuth: false,
      liveChat: false,
    },
  },
  {
    path: "/auth/support-center/information",
    name: "InformationCenter",
    component: IndexInformationCenter,
    meta: {
      title: "Information Center",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/support-center/information/availment-process",
    name: "InformationCenterAvailment",
    component: IndexInformationCenterAvailment,
    meta: {
      title: "Availment Process",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/support-center/information/faq",
    name: "InformationCenterFAQ",
    component: IndexInformationCenterFAQ,
    meta: {
      title: "FAQ",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/support-center/information/videos",
    name: "InformationCenterVideo",
    component: IndexInformationCenterVideos,
    meta: {
      title: "Video Guides",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
  {
    path: "/auth/contact/detail",
    name: "ContactUs",
    component: IndexContactUsPage,
    meta: {
      title: "Contact Us",
      layout: "Account",
      requiresAuth: true,
      liveChat: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `AMAP`;

  // ✅ If acct=ims → redirect to external site
  if (to.query.acct === "ims") {
    window.location.href = "https://ims-anec-benefits.ims.com.ph/public/";
    return;
  }

  const token = localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN);
  const isAuthenticate = !!token;

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticate) {
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    if ((to.name === "auth" || to.name === "onboard") && isAuthenticate) {
      next({ path: "/auth/home" });
    } else {
      next();
    }
  }
});
export default router;
